import React from 'react';
import {get} from 'lodash';

import FractionInput from './FractionInput';
import {processStringContent} from 'utils/content';


export default (props) => {

    const renderInput = (fieldKey) => {
        const fieldData = get(props.itemData, ['inputs', fieldKey]);
        return (
            <FractionInput
                component_data={props.component_data}
                is_preview={props.is_preview}
                answer={props.answer}
                existing_answer={props.existing_answer}
                onChange={props.onChange(fieldKey)}
                fieldData={fieldData}
                fieldKey={fieldKey}
                fractionKey={props.fractionKey}
            />
        );
    }

    const renderText = (fieldKey) => {
        const fieldData = get(props.itemData, ['texts', fieldKey]);
        if (fieldData) {
            return (
                <div
                    className="cc-fraction-text"
                    style={fieldData.style}
                >
                    {processStringContent(fieldData.content.html)}
                </div>
            )
        }
    }

    const fractionStyle = get(props.itemData, 'style');
    const dividerStyle = get(props.itemData, 'divider.style');

    return (
        <div className="cc-fraction-fractionpart" style={fractionStyle}>
            <div className="flex-row flex-v-center">
                {renderInput('front')}
                {renderText('front')}
                <div className="flex-column flex-v-center">
                    {renderInput('top')}
                    {renderText('top')}
                    <div className="cc-fraction-divider" style={dividerStyle}></div>
                    {renderInput('bottom')}
                    {renderText('bottom')}
                </div>
            </div>
        </div>
    )
}